<template>
    <div class="verify">
        <h2>Verifizierung</h2>
        <p v-if="sendingCode">Sende Code an **-173 ...</p>
        <p v-if="codeSent">{{ codeSentText }} <br /> Bitte gebe den 4 stelligen Code ein:</p>
        <div class="d-flex verification-digits justify-content-center" :class="inputClass">
            <input type="number" max-length="1" min="0" max="9" class="verification-digit">
            <input type="number" max-length="1" min="0" max="9" class="verification-digit">
            <input type="number" max-length="1" min="0" max="9" class="verification-digit">
            <input type="number" max-length="1" min="0" max="9" class="verification-digit">
        </div>
        <div class="text-center my-3">
            <span v-if="fetchingVerification">Code wird verifiziert</span>
            <span v-if="fetchingVerificationError" class=" text-danger">{{ fetchingVerificationError }}</span>
            <span v-if="fetchingVerificationSuccess">Code ist korrekt. Du wirst weitergeleitet.</span>
        </div>
        <div class="text-center"><a href="#" class="link-dark" @click.prevent="resendCode" v-if="jobs_hash">Code erneut senden</a></div>
        <!-- <Button @obClick="gotoConfirmation">Bestätigen</Button> -->
    </div>
</template>

<script>
import Button from '../components/ux/Button.vue';
import router from '../router';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "Verify",
    components: { Button },
    computed: {
        ...mapGetters("orders", [
            "fetching",
            "fetchingErrorCode",
            "fetchingError",
            "baseData",
            "verificationCode",
            "fetchingVerification",
            "fetchingVerificationSuccess",
            "fetchingVerificationError",
            "sendingCode",
            "codeSent",
            "codeSentText",
            "jobs_hash"
        ]),
        inputClass() {
            if (this.fetchingVerificationError) {
                return "has-errors";
            }

            if (this.fetchingVerificationSuccess) {
                return 'success';
            }

            return '';
        }
    },
    mounted() {
        this.focusFirst();
        this.nextField();
    },
    methods: {
        ...mapActions('orders', ['setVerificationDigit', 'checkVerifyCode', 'resetCode']),
        gotoConfirmation() {
            this.$options.methods.scrollTop();
            router.push('Confirmation');
            this.$store.dispatch("orders/navigate", 6);
        },
        focusFirst() {
            const fields = document.querySelectorAll('input[type="number"]');
            fields[0].focus();
        },
        nextField() {
            const fields = document.querySelectorAll('input[type="number"]');
            fields.forEach(el => {
                el.onkeyup = (e) => {
                    // el.disabled = true;
                    this.setVerificationDigit({
                        digit: el.value
                    });
                    if (el.nextElementSibling) {
                        el.nextElementSibling.focus()
                    } else {
                        this.verifyCode();
                    }
                }
            });
        },
        resendCode() {
            const fields = document.querySelectorAll('input[type="number"]');
            fields.forEach(el => { el.disabled = false; el.value = ''; });
            this.resetCode();
        },
        async verifyCode() {
            const codeok = await this.checkVerifyCode();
            if (codeok) {
                this.$options.methods.scrollTop();
                this.$options.methods.goToPath({ name: "Confirmation", step: 6 })
            }
        }
    }
}
</script>

<style lang="scss">

    .verification-digits {
        column-gap: 20px;
        margin: 42px 0 0;
    }

    input.verification-digit {
        text-align: center;
        border: 1px solid $border-color;
        width: 50px;
        height: 50px;
        padding: 0;
        font-size: 33px;

        .has-errors & {
            border-color: $danger-color;
        }

        .success & {
            border-color: $success-color;
        }
    }

    @media (min-width: 768px) {
        .verify {
            padding: 30px;
            border: 1px solid $border-color;
            margin-top: 54px;
            margin-bottom: 100px;
        }
    }
</style>